import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

interface IRectangleLoaderProps {
  width?: string | number;
  height?: string | number;
  customStyle?: any;
  backgroundColor?: string;
  borderRadius?: string;
  testId?: string;
}

const RectangleLoader = ({
  width,
  height,
  customStyle,
  backgroundColor,
  borderRadius,
  testId
}: IRectangleLoaderProps) => {
  return (
    <Skeleton
      data-testid={testId ?? "rectangle-loader"}
      variant="rectangular"
      width={width}
      height={height}
      sx={[
        {
          background: backgroundColor ?? colors.gray100,
          borderRadius: borderRadius ?? "6px"
        },
        customStyle
      ]}
    />
  );
};

export default RectangleLoader;
